module.exports = __webpack_public_path__ + "img/catF.d85bf594.svg";